export const DEFAULT_DESIGN = {
  colors: {
    popupBackground: "#ffffff",
    borderColor: "#e5e7eb",
    titleColor: "#000000",
    optionTextColor: "#374151",
    selectedColor: "#000000",
    otherInputBackground: "#f9fafb",
    buttonBackground: "#000000",
    buttonTextColor: "#ffffff",
    hoverColor: "#f3f4f6",
    aiMessageBackground: "#f3f4f6",
    aiMessageText: "#374151",
    visitorMessageBackground: "#000000",
    visitorMessageText: "#ffffff",
  },
  typography: {
    titleSize: 18,
    titleWeight: "medium",
    optionSize: 14,
    optionWeight: "normal",
    buttonTextSize: 16,
    buttonTextWeight: "normal",
    otherInputSize: 14,
  },
  spacing: {
    popupPaddingY: 0,
    popupPaddingX: 0,
    titleBottomMargin: 0,
    optionSpacing: 6,
    buttonTopMargin: 2,
  },
  size: {
    borderRadius: 16,
    shadowIntensity: "default",
    borderWidth: 1,
  },
  text: {
    submitButtonText: "Share Response",
    assistantTitle: "AI Survey Assistant",
    inputPlaceholder: "Type your answer...",
    chatButtonText: "Need help? Chat with us",
  },
  presentation: {
    style: "center-modal",
    position: "center",
    slideDirection: "right",
    cornerPosition: "bottom-right",
  }
};
